import React from 'react'
import PropTypes from 'prop-types'

import FunctionUtils from '../../../../lambda/FunctionUtils'

export class TextModule extends React.Component {

  static propTypes = {
    jobInfo: PropTypes.shape()
  }

  constructor(props, numberOfLines = 1) {
    super(props)
    this.numberOfLines = numberOfLines
    this.state = {
      jobInfo: props.jobInfo,
      value: this.getModuleInfo(props.jobInfo)
    }
  }

  getPlaceholder() {
    return ''
  }

  componentWillReceiveProps(nextProps) {
    this.setState({
      jobInfo: nextProps.jobInfo,
      value: this.getModuleInfo(nextProps.jobInfo)
    })
  }

  setModuleInfo(value) {
    FunctionUtils.updateModule(this.state.jobInfo, this.getModulePath(), value, true)
  }

  setValue(value){
    this.setState({value: value})
  }

  render(controller) {
    return (
      <div
        style={styles.container}>
        <div style={styles.label}>
          {controller.getLabelText()}
        </div>
        { this.numberOfLines === 1
          ? <input
            style={styles.input}
            type="text"
            ref="input"
            value={this.state.value}
            placeholder={this.getPlaceholder()}
            onChange={() => {
              this.setModuleInfo(this.refs.input.value)
              this.setValue(this.refs.input.value)
            }}/>
          : <textarea
            style={{ ...styles.input, ...styles.textArea }}
            ref="input"
            rows={this.numberOfLines}
            value={this.state.value}
            placeholder={this.getPlaceholder()}
            onChange={() => {
              this.setModuleInfo(this.refs.input.value)
              this.setValue(this.refs.input.value)
            }}/>
        }
      </div>
    )
  }

}

export class TargetModule extends TextModule {

  constructor(props) {
    super(props, 1)
  }

  getLabelText() {
    return 'Time budgeted (min)'
  }

  getModulePath() {
    return '/modules/' + this.props.moduleName + '/target'
  }

  getModuleInfo(jobInfo) {
    return jobInfo.modules[this.props.moduleName].target
  }

  render() {
    return super.render(this)
  }

}

const styles = {

  container: {
    display: 'flex',
    flexDirection: 'column'
  },

  input: {
    fontSize: 14,
    padding: '7px 11px 7px 11px',
    backgroundColor: '#fefefe',
    borderRadius: 3,
    boxShadow: 'inset 0 2px 2px 0 rgba(0, 0, 0, 0.05)',
    border: 'solid 1px rgba(0, 0, 0, 0.12)'
  },

  textArea: {
    resize: 'none'
  },

  label: {
    fontSize: 14,
    color: '#757575',
    marginBottom: 6
  }

}


// WEBPACK FOOTER //
// ./src/schedule/common/modules/text/TextModules.js